import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from "../Vas";
import '../css/TransdevMenue.css';
import SideNavigation from './SideNavigation';
import { DateTimeHelper } from 'utils-lib';
import { Icon, MessageBox } from 'component-lib';

import { RequestAjaxClass, PaymentsModel } from 'models-lib';

var moment = require('moment');
        moment().format();
class TransdevMenue extends Component{

    static PersonalDataLinkClass = "NavBarItem ItemData";    
    static NewContractDataLinkClass = "NavBarItem ItemNewContract";  
    static ContractDataLinkClass = "NavBarItem ItemContracts";
    static UsernameDataLinkClass = "NavBarItem ItemAccount";
    static CustomersDataLinkClass = "NavBarItem ItemCustomers";
    static LanguageDataLinkClass = "languageMenuLogin";
    static HomeDataLinkClass = "NavBarItem ItemHome";

    static PersonalDataLinkText = "LinkTextOnline";    
    static NewContractDataLinkText = "LinkTextOnline";  
    static ContractDataLinkText = "LinkTextOnline";
    static UsernameDataLinkText = "LinkTextOnline";
    static CustomersDataLinkText = "LinkTextOnline";
    static LanguageDataLinkText = "LinkTextOnline";
    static HomeDataLinkText = "LinkTextOnline";

    static Empty = "ItemEmpty";
    static SignOut = "NavBarItem ItemSignOut";

    static SignOutLinkText = "LinkTextOnline";
 
    constructor(props){
      super(props);
      this.Request = new RequestAjaxClass();
      this.PaymentsModel = new PaymentsModel([this]);

      this.LangConfig = Vas.Config.Languages;

      this.AdminConfig = Vas.Config.Administrator;
    }

    componentDidMount(){

      this.Request.setAuth(true);
      this.Request.setApiKey(Vas.ApiKey);
      this.Request.setApiUrl(Vas.ApiUrl);

      this.PaymentsModel.SetRequest(this.Request);

      this.FontSizeClick(false);

      this.LogoClick(false);
    }

    componentWillUnmount(){
      this.LogoClick(false);
    }

    Update(observer){
      let me = this;
      this.setState({},()=>{
        if(observer === "Payment"){
          let count = this.PaymentsModel.Count;
          let id = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id') : localStorage.getItem('vas_customerId');
          if (count > 0){
              let valid = false;
              let today = moment();
              me.PaymentsModel.Payments.forEach(p => {
                  if(p.ValidFrom !== null){
                      if(today.isAfter(DateTimeHelper.StringToDate(p.ValidFrom,true, localStorage.getItem('vas_language'))) === true){
                          valid = true;
                      }
                  }else{
                      valid = true;
                  }
              })
              if(valid === true){
                Vas.GetView("Order", { CustomerId: id, ContractId : '00000' }, true);
              }else {
                Vas.GetView("NoPayment", { CustomerId: id, NewContract : "true" }, true);
              }
          } else {
            Vas.GetView("NoPayment", { CustomerId: id, NewContract : "true" }, true);
          }
        }
      });
    }

    showFlags(){
        $("#MenuItemsLang").removeClass().addClass("languageMenuLogin-items");
    }

    hideFlags(){
        $("#MenuItemsLang").removeClass().addClass("languageMenuLogin-items-notVisible");
    }

    logout(){
        Vas.Signout();
    };

    DeselectTabs(){

        TransdevMenue.PersonalDataLinkClass = "NavBarItem ItemData";    
        TransdevMenue.NewContractDataLinkClass = "NavBarItem ItemNewContract";
        TransdevMenue.ContractDataLinkClass = "NavBarItem ItemContracts";
        TransdevMenue.UsernameDataLinkClass = "NavBarItem ItemAccount";
        TransdevMenue.CustomersDataLinkClass = "NavBarItem ItemCustomers";
        TransdevMenue.HomeDataLinkClass = "NavBarItem ItemHome";

        TransdevMenue.PersonalDataLinkText = "LinkTextOnline";    
        TransdevMenue.NewContractDataLinkText = "LinkTextOnline";  
        TransdevMenue.ContractDataLinkText = "LinkTextOnline";
        TransdevMenue.UsernameDataLinkText = "LinkTextOnline";
        TransdevMenue.CustomersDataLinkText = "LinkTextOnline";
        TransdevMenue.LanguageDataLinkText = "LinkTextOnline";
        TransdevMenue.HomeDataLinkText = "LinkTextOnline";
    }

    SelectTab(id){

        switch (id)
        {
            case "PersonalDataLink":
                TransdevMenue.PersonalDataLinkClass = "NavBarItem ItemData active";    
                TransdevMenue.PersonalDataLinkText = "LinkTextOnline active";
                break;

            case "NewContractDataLink":
                TransdevMenue.NewContractDataLinkClass = "NavBarItem ItemNewContract active";    
                TransdevMenue.NewContractDataLinkText = "LinkTextOnline active";
                break;

            case "ContractDataLink":   
                TransdevMenue.ContractDataLinkClass = "NavBarItem ItemContracts active";
                TransdevMenue.ContractDataLinkText = "LinkTextOnline active";
                break;

            case "UsernameDataLink":
                TransdevMenue.UsernameDataLinkClass = "NavBarItem ItemAccount active";
                TransdevMenue.UsernameDataLinkText = "LinkTextOnline active";
                break;

            case "CustomersDataLink":
                TransdevMenue.CustomersDataLinkClass = "NavBarItem ItemCustomers active";
                TransdevMenue.CustomersDataLinkText = "LinkTextOnline active";
                break;

            case "HomeDataLink":
                TransdevMenue.HomeDataLinkClass = "NavBarItem ItemHome active";
                TransdevMenue.HomeDataLinkText = "LinkTextOnline active";
                break;
            
            default: break;
        }
    }

    SetLanguage(lang){
      if(lang === "en"){
        if(this.LangConfig.MessageChangeToEnglish === true){
          ReactDOM.render(<MessageBox 
            AppURL={Vas.ApplicationUrl} 
            Title={Vas.Resources.Titles["Note"]} 
            Message={<div>
              {Vas.Resources.Labels["NoteChangeLanguageGerman"]}
              {<br/>}
              {Vas.Resources.Labels["NoteChangeLanguageEnglish"]}
            </div>}
            Click={()=>{
              localStorage.setItem("vas_language", lang);
              window.location = window.location.pathname;
            }} /> 
            , document.getElementById('messageContainer'));
        }else{
          localStorage.setItem("vas_language", lang);
          window.location = window.location.pathname;
        }
      }else{
        localStorage.setItem("vas_language", lang);
        window.location = window.location.pathname;
      }
        

        /*let language = localStorage.getItem('vas_language');
        let supportedLanguages = require('./i18n/languages.json');
        supportedLanguages.Languages.forEach(function(value){
            if(value.Iso !== language){
                localStorage.setItem("vas_language", value.Iso);
                window.location = window.location.pathname;
            }
        });*/
    }

    LogoClick(condition){
      var kontrastNumber = localStorage.getItem('Kontrast');
      var schriftgröße = localStorage.getItem('Schriftgröße');
      let role = localStorage.getItem("vas_role");

      if(kontrastNumber == "false"){
        if(condition){
      
          $('#DataTabLinkBurgerMenu').mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; color: black !important;');
              $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
          });

          $('#PaymentTabLinkBurgerMenu').mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; color: black !important;');
              $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
          });

          $('#DocumentTabLinkBurgerMenu').mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; color: black !important;');
              $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
          });

          $('#CertificateTabLinkBurgerMenu').mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; color: black !important;');
              $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
          });

          $('#AddidionalAdressesTabLinkBurgerMenu').mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; color: black !important;');
              $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
          });

          $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
          $(".NavBar").attr('style', 'background-color: #1d5c87;');
          $(".active").attr('style', 'background-color: #00375b;');
          $(".NavBarItem :hover").attr('style', 'background-color: #00375b;');
          $(".NavBarItem").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
              $(".active").attr('style', 'background-color: #00375b;');
          });
          $(".languageMenuLogin").attr('style', 'background-color: #1d5c87;');
          $(".languageMenuLogin-items").attr('style', 'background-color: #1d5c87; border: 1px solid #1d5c87;');
          $("#MenuItemsLang").attr('style', ' border: 1px solid #1d5c87;');
          $('#LanguagesButon').attr('style', 'margin-left: 10px; border: medium none; background-color: #1d5c87;');
          $('#LanguageButtonDeu').attr('style', 'border: medium none !important; background-color: #1d5c87;');
          $('#LanguageButtonEng').attr('style', 'border: medium none !important; background-color: #1d5c87;');
          $('.customerCard').attr('style', 'border: 1px solid #1d5c87;');
          $('#languageDivDeu').attr('style', 'background-color: #1d5c87; border-bottom-color: #1d5c87;');
          $('#languageDivEng').attr('style', 'background-color: #1d5c87; border-bottom-color: #1d5c87;');
          $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87; color: #1d5c87;');
          $(".activeTab").attr('style', 'background-color: #1d5c87;');
          $('.tab').attr('style', 'background-color: #ffffff; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
          $(".customerCardLinks td").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
              $(".activeTab").attr('style', 'background-color: #1d5c87;');
          }).mousedown(function() {
            $("#DataTabLink").removeClass().addClass("tab");
            $("#PaymentTabLink").removeClass().addClass("tab");
            $("#DocumentTabLink").removeClass().addClass("tab");
            $("#CertificateTabLink").removeClass().addClass("tab");
            $("#AddidionalAdressesTabLink").removeClass().addClass("tab");
            $("#ContractDataTabLink").removeClass().addClass("tab");
            $("#RelationDeleteTabLink").removeClass().addClass("tab");
            $('.tab').attr('style', 'color: black; background-color: #ffffff; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
            $("#UsernameDataLink").attr('style', 'background-color: #1d5c87; color: white; border-right: 1px solid #ffffff;');
            $(this).attr('style', 'background-color: #1d5c87;');
          });

          $("#UsernameDataLink").attr('style', 'background-color: #1d5c87; color: white;');
          $("#SignoutDataLink").attr('style', 'background-color: #1d5c87;');

          $('#PersonalDataLink').attr('style', 'background-color: #1d5c87;');
          $('#NewContractDataLink').attr('style', 'background-color: #1d5c87;');
          $('#ContractDataLink').attr('style', 'background-color: #1d5c87;');
          $('.active').attr('style', 'background-color: #00375b;');
          
          $('.MessageBoxTitle').attr('style', 'background-color: #1d5c87;');
          $('.modalLoadingBox').attr('style', 'background-color: rgba(29, 92, 135, 0.6);');
          $('#messageBoxExtendedButton').attr('style', 'background-color: #1d5c87; width: 150px; float: right;');
          $('.SideNav').attr('style', 'width: auto; background-color: #1d5c87;');
          $(".SideNav table td").mouseenter(function() {
            $(this).attr('style', 'color: white; cursor: pointer; background-color: #00375b;');
          }).mouseleave(function() {
              $(this).attr('style', 'color: white; cursor: pointer; background-color: #1d5c87;');
          });
  
          //Forms
          $('.tariffingForm').attr('style', 'text-align: left; border-bottom: 1px solid #1d5c87;');

          $('.contractForm .pagingTable th, .contractForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
          $('.customerForm .pagingTable th, .customerForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');

          if (role === '3'){
            $('.contractForm th[id="0"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 92px !important; cursor: pointer; padding-right: 130px !important;');
            $('.contractForm th[id="1"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 195px !important;');
            $('.contractForm th[id="2"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 195px !important;');
            $('.contractForm th[id="3"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 130px !important;');
            $('.contractForm th[id="4"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 130px !important;');
            $('.contractForm th[id="5"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 95px !important; cursor: pointer;');
            $('.contractForm th[id="6"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 95px !important; cursor: pointer;');
            $('.contractForm th[id="7"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; cursor: pointer;');

            $('.panel').attr('style', 'border: 1px solid #1d5c87; box-shadow: 10px 10px 15px #1d5c87;');
            $('.panelHeader').attr('style', 'background-color: #1d5c87;');
            $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');
          }
  
          //Buttons
          $('.extendedButton, .pagingButton').attr('style', 'background-color: #1d5c87;');
          $('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #1d5c87; width: 30px; height: 30px;');
          $('.extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#changeMail').attr('style', 'width: 175px; float: left; background-color: #1d5c87;');
          $('#changeMailCancel').attr('style', 'width: 175px; float: right; background-color: #1d5c87;');
          $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #1d5c87; width: 100px;');

          //Msc Fields
          $('.checkbox').attr('style', 'accent-color: #1d5c87; float: left; margin-left: 0px;');
          $('.focusedCheckBox').attr('style', 'accent-color: #1d5c87; float: left; margin-left: 0px;');
  
          //Fields
          $('.textfield').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.textfieldDisabled').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.textfield#EMail').attr('style', 'width: 280px;');
          $('.datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox').attr('style', 'color: rgb(89, 89, 89);');
          $('.registerform > div:nth-child(1) > div:nth-child(7) > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) > label:nth-child(1)').attr('style', 'width: 390px; float: left;');
          $('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #1d5c87;');
          $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
          $('#FileTextLabel').attr('style', 'width: 300px; float: left;');
          $('#email2').attr('style', 'width: 360px; float: border-bottom: 1px dotted #1d5c87;');

          $('.documentUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px;');
          $('.documentUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.documentUploadForm #btoCancel').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          
          $('.createPaymentForm #iban2').attr('style', 'border-bottom: 1px dotted #1d5c87; width: 315px;');
          $('.createPaymentForm #bic2').attr('style', 'border-bottom: 1px dotted #1d5c87; width: 320px;');
          $('.createPaymentForm #nameOfBank2').attr('style', 'border-bottom: 1px dotted #1d5c87; width: 350px;');

          $('#CertificateType').attr('style', 'width: 340px; float: left; border-bottom: 1px dotted #1d5c87;');
          $('.verificationUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px; float: left;');
          $('.verificationUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.verificationUploadForm #btoClose').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');

          $('#AddressTypes').attr('style', 'border-bottom: 1px dotted #1d5c87;');

          //CustomerPayment
          $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87; color: #1d5c87;');
          $('.createPaymentForm .pagingTable th, .createPaymentForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
          $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
          //$('.createPaymentForm .pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');

          $('.createPaymentForm #PaymentTerms').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.createPaymentForm #CreatePayment').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.createPaymentForm #Cancel').attr('style', 'background-color: #1d5c87; width: 170px; float: right;');

          $('.createPaymentForm #ValidFrom').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');
          $('.createPaymentForm #ValidTo').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');
          $('.createPaymentForm #DateOfBirth').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');

          //PagingTable
          $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
          $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
          $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          }).mouseleave(function() {
            $(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
          });

          $(".selected").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          });

        $(".selected").attr('style', 'background-color: #1d5c87; border-bottom: 1px solid #1d5c87;');
        
        $('#btoChoose').attr('style', 'background-color: #1d5c87; width: 100px;');
        $('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #1d5c87;');

        $('#oldPassword').attr('style', 'width: 250px !important; border-bottom: 1px dotted #1d5c87;');
        $('#newPassword').attr('style', 'width: 230px !important; border-bottom: 1px dotted #1d5c87;');
        $('#retypePassword').attr('style', 'width: 250px !important; border-bottom: 1px dotted #1d5c87;');
        $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
        $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
        $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

        $('.changePasswordForm .extendedButton').attr('style', 'width: 125px; float: left; background-color: #1d5c87;');
        
        //OrderForm
        $(".orderForm .StepperIconActive").attr('style', 'background-color: #1d5c87;');
        $('.orderForm .StepperIcon').attr('style', 'background-color: none;');
        $('.orderForm').attr('style', 'border: 1px solid #1d5c87;');
        $('.orderForm #buttonContinue1').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

        $('.orderForm .selectField').attr('style', 'border-bottom: 1px dotted #1d5c87;');

        $('.orderForm #TariffProducts').attr('style', 'width: 350px; border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #ContractStart').attr('style', 'width: 210px; border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #Via').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #ContractEnd').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.orderForm #PaymentTerms').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonBack2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonContinue2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #TariffProduct_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #Payment_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #buttonBack3').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
        $('.orderForm #btoOrderOrder').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

        $(".orderForm .extendedButton").mouseenter(function() {
          $(this).attr('style', 'background-color: #00375b; width: 180px; float: left;');
      }).mouseleave(function() {
          $(this).attr('style', 'background-color: #1d5c87; width: 180px; float: left;');
        });

        //CustomerDucoments
        $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
        $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');
        $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');  

        //DocumentUpload
        $('.documentUploadForm').attr('style', 'border: 1px solid #1d5c87;');
        $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('.documentUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px !important;');
        $('.documentUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px !important; float: left;');
        $('.documentUploadForm #btoCancel').attr('style', 'background-color: #1d5c87; width: 170px !important; float: left;');

        //VerificationUpload
        $('.verificationUploadForm').attr('style', 'border: 1px solid #1d5c87;');
        $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('#CertificateType').attr('style', 'width: 340px; float: left; border-bottom: 1px dotted #1d5c87;');
        $('.verificationUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px; float: left;');
        $('.verificationUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
        $('.verificationUploadForm #btoClose').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');

        //CreateAdditionalAddress
        $('#AddressTypes').attr('style', 'border-bottom: 1px dotted #1d5c87;');
        $('.CreateAdditionalAddressForm #btoCreateAAddress').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
        $('.CreateAdditionalAddressForm #Cancel').attr('style', 'background-color: #1d5c87; width: 170px; float: right;');
        $('.CreateAdditionalAddressForm .textfield').attr('style', 'width: 170px; border-bottom: 1px dotted #1d5c87;');
        $('.CreateAdditionalAddressForm #Street').attr('style', 'width: 375px; border-bottom: 1px dotted #1d5c87;');

        //Contracts
        $('#MenuItem_Download_CSV').attr('style', 'background-color: #1d5c87;');
        $('#MenuItem_Add').attr('style', 'background-color: #1d5c87;');

        //Account
        $(".accountForm #btoChangePassword").attr('style', 'width: 170px; background-color: #1d5c87;');
        $(".accountForm #btoDeleteAccount").attr('style', 'width: 170px; background-color: #1d5c87;');
        $('.accountForm').attr('style', 'border: 1px solid #1d5c87;');

          $('.footer').attr('style', 'background-color: #1d5c87;');
          $('.activeTabTerms').attr('style', 'background-color: #00375b;');
          $('.tabTerms').attr('style', 'background-color: #1d5c87;');


          $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

          $('#CancelationReasons').attr('style', 'width: 360px; border-bottom: 1px dotted #1d5c87;');
        $('#Check').attr('style', 'width: 177px; float: left; background-color: #1d5c87;');
        $('#Abort').attr('style', 'width: 172px; float: left; background-color: #1d5c87;');

        $('#PopUpBoxdpCancelationDateHeader').attr('style', 'background-color: #1d5c87;');

        if(schriftgröße == "5" || schriftgröße == "0"){
          $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
          $('#Cancel').attr('style', 'width: 394px; float: right; background-color: #1d5c87;');
          $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
        }

        $('#btoOrderChange').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

        $('.selected').attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          localStorage.setItem('Kontrast', 'true');
        }
      } else{

          if(condition){
            localStorage.setItem('Kontrast', 'false');

            $('#DataTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #3393d3; color: white !important;');
            });

            $('#PaymentTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #3393d3; color: white !important;');
            });

            $('#DocumentTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #3393d3; color: white !important;');
            });

            $('#CertificateTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #3393d3; color: white !important;');
            });

            $('#AddidionalAdressesTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #3393d3; color: white !important;');
            });

            $(".activeTabBurgerMenu").attr('style', 'background-color: #3393d3; color: white !important;');

            $(".NavBar").attr('style', 'background-color: #3393d3;');
            $(".active").attr('style', 'background-color: #0078c8;');
            $(".NavBarItem :hover").attr('style', 'background-color: #0078c8;');
            $(".NavBarItem").mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #3393d3;');
                $(".active").attr('style', 'background-color: #0078c8;');
            });
            $(".languageMenuLogin").attr('style', 'background-color: #3393d3;');
            $(".languageMenuLogin-items").attr('style', 'background-color: #3393d3; border: 1px solid #3393d3;');
            $("#MenuItemsLang").attr('style', ' border: 1px solid #3393d3;');
            $('#LanguagesButon').attr('style', 'margin-left: 10px; border: medium none; background-color: #3393d3;');
            $('#LanguageButtonDeu').attr('style', 'border: medium none !important; background-color: #3393d3;');
            $('#LanguageButtonEng').attr('style', 'border: medium none !important; background-color: #3393d3;');
            $('.customerCard').attr('style', 'border: 1px solid #3393d3;');
            $('#languageDivDeu').attr('style', 'background-color: #3393d3; border-bottom-color: #3393d3;');
            $('#languageDivEng').attr('style', 'background-color: #3393d3; border-bottom-color: #3393d3;');
            $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #3393d3; color: 3393d3;');
            $(".activeTab").attr('style', 'background-color: #0078c8;');
            $('.tab').attr('style', 'background-color: #ffffff; border-right: 1px solid #3393d3; border-bottom: 1px solid #3393d3');
            $(".customerCardLinks td").mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3; border-right: 1px solid #3393d3; border-bottom: 1px solid #3393d3');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; border-right: 1px solid #3393d3; border-bottom: 1px solid #3393d3');
                $(".activeTab").attr('style', 'background-color: #0078c8;');
            }).mousedown(function() {
              $("#DataTabLink").removeClass().addClass("tab");
              $("#PaymentTabLink").removeClass().addClass("tab");
              $("#DocumentTabLink").removeClass().addClass("tab");
              $("#CertificateTabLink").removeClass().addClass("tab");
              $("#AddidionalAdressesTabLink").removeClass().addClass("tab");
              $("#ContractDataTabLink").removeClass().addClass("tab");
              $("#RelationDeleteTabLink").removeClass().addClass("tab");
              $('.tab').attr('style', 'color: black; background-color: #ffffff; border-right: 1px solid #3393d3; border-bottom: 1px solid #3393d3');
              $("#UsernameDataLink").attr('style', 'background-color: #3393d3; color: white; border-right: 1px solid #ffffff;');
              $(this).attr('style', 'background-color: #ffffff;');
            });

            $("#UsernameDataLink").attr('style', 'background-color: #3393d3; color: white; border-right: 1px solid #ffffff;');
            $("#SignoutDataLink").attr('style', 'background-color: #3393d3;');

            $('#PersonalDataLink').attr('style', 'background-color: #3393d3;');
            $('#NewContractDataLink').attr('style', 'background-color: #3393d3;');
            $('#ContractDataLink').attr('style', 'background-color: #3393d3;');
            $('.active').attr('style', 'background-color: #0078c8;');

            $('.MessageBoxTitle').attr('style', 'background-color: #3393d3;');
            $('.modalLoadingBox').attr('style', 'background-color: rgba(29, 92, 135, 0.6);');
            $('#messageBoxExtendedButton').attr('style', 'background-color: #3393d3; width: 150px; float: right;');
            $('.SideNav').attr('style', 'width: auto; background-color: #3393d3;');
            $(".SideNav table td").mouseenter(function() {
              $(this).attr('style', 'color: white; cursor: pointer; background-color: #0078c8;');
            }).mouseleave(function() {
                $(this).attr('style', 'color: white; cursor: pointer; background-color: #3393d3;');
            });
  
            //Forms
            $('.tariffingForm').attr('style', 'text-align: left; border-bottom: 1px solid #3393d3;');

            $('.contractForm .pagingTable th, .contractForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');
            $('.customerForm .pagingTable th, .customerForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');

            if (role === '3'){

              $('.contractForm .pagingTable th, .contractForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');

              $('.contractForm th[id="0"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 92px !important; cursor: pointer; padding-right: 130px !important;');
              $('.contractForm th[id="1"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 195px !important;');
              $('.contractForm th[id="2"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 195px !important;');
              $('.contractForm th[id="3"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 130px !important;');
              $('.contractForm th[id="4"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 130px !important;');
              $('.contractForm th[id="5"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 95px !important; cursor: pointer;');
              $('.contractForm th[id="6"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; width: 95px !important; cursor: pointer;');
              $('.contractForm th[id="7"]').attr('style', 'color: #3393d3; border-bottom: 1px solid #3393d3; cursor: pointer;');

              $('.panel').attr('style', 'border: 1px solid #3393d3; box-shadow: 10px 10px 15px #3393d3;');
              $('.panelHeader').attr('style', 'background-color: #3393d3;');
              $('#MenuItem_Hinzufügen').attr('style', 'background-color: #3393d3;');
            } else {
              $('.contractForm .pagingTable th, .contractForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');
            }
  
            //Buttons
            $('.extendedButton, .pagingButton').attr('style', 'background-color: #3393d3;');
            $('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #3393d3; width: 30px; height: 30px;');
            $('.extendedButton').attr('style', 'width: 120px; float: right; background-color: #3393d3;');
            $('#changeMail').attr('style', 'width: 175px; float: left; background-color: #3393d3;');
            $('#changeMailCancel').attr('style', 'width: 175px; float: right; background-color: #3393d3;');

            //Msc Fields
            $('.checkbox').attr('style', 'accent-color: #3393d3; float: left; margin-left: 0px;');
            $('.focusedCheckBox').attr('style', 'accent-color: #3393d3; float: left; margin-left: 0px;');
    
            //Fields
            $('.textfield').attr('style', 'border-bottom: 1px dotted #3393d3;');
            $('.textfieldDisabled').attr('style', 'border-bottom: 1px dotted #3393d3;');
            $('.textfield#EMail').attr('style', 'width: 280px;');
            $('.datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox').attr('style', 'color: rgb(89, 89, 89);');
            $('.registerform > div:nth-child(1) > div:nth-child(7) > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) > label:nth-child(1)').attr('style', 'width: 390px; float: left;');
            $('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #3393d3;');
            $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #3393d3;');
            $('#FileTextLabel').attr('style', 'width: 300px; float: left;');
            $('#email2').attr('style', 'width: 360px; float: border-bottom: 1px dotted #3393d3;');

            $('.documentUploadForm #btoChoose').attr('style', 'background-color: #3393d3; width: 150px;');
            $('.documentUploadForm #btoFileUpload').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.documentUploadForm #btoCancel').attr('style', 'background-color: #3393d3; width: 170px; float: left;');

            $('.createPaymentForm #PaymentTerms').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.createPaymentForm #CreatePayment').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.createPaymentForm #Cancel').attr('style', 'background-color: #3393d3; width: 170px; float: right;');
            
            $('.createPaymentForm #iban2').attr('style', 'border-bottom: 1px dotted #3393d3; width: 315px;');
            $('.createPaymentForm #bic2').attr('style', 'border-bottom: 1px dotted #3393d3; width: 320px;');
            $('.createPaymentForm #nameOfBank2').attr('style', 'border-bottom: 1px dotted #3393d3; width: 350px;');

            $('#CertificateType').attr('style', 'width: 340px; float: left; border-bottom: 1px dotted #3393d3;');
            $('.verificationUploadForm #btoChoose').attr('style', 'background-color: #3393d3; width: 150px; float: left;');
            $('.verificationUploadForm #btoFileUpload').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.verificationUploadForm #btoClose').attr('style', 'background-color: #3393d3; width: 170px; float: left;');

            $('#AddressTypes').attr('style', 'border-bottom: 1px dotted #3393d3;');

            //CustomerPayment
            $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #3393d3; color: 3393d3;');
            $('.createPaymentForm .pagingTable th, .createPaymentForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #3393d3; border-bottom: 1px solid #3393d3;');
            $('#MenuItem_Bearbeiten').attr('style', 'background-color: #3393d3;');
            $('.createPaymentForm .pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #3393d3;');

            $('.createPaymentForm #PaymentTerms').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.createPaymentForm #CreatePayment').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.createPaymentForm #Cancel').attr('style', 'background-color: #3393d3; width: 170px; float: right;');

            $('.createPaymentForm #ValidFrom').attr('style', 'background-color: #3393d3; width: 140px; float: left;');
            $('.createPaymentForm #ValidTo').attr('style', 'background-color: #3393d3; width: 140px; float: left;');
            $('.createPaymentForm #DateOfBirth').attr('style', 'background-color: #3393d3; width: 140px; float: left;');

            //PagingTable
            $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
            $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
            $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
            }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #3393d3;');
            });

            $(".selected").mouseenter(function() {
              $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
            }).mouseleave(function() {
              $(this).attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
            });

            $(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").attr('style', 'background-color: rgba(51, 147, 211, 0.1); border-bottom: 1px solid #3393d3;');
            
            $('#btoChoose').attr('style', 'background-color: #3393d3; width: 100px;');
            $('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #3393d3;');

            $('#oldPassword').attr('style', 'width: 250px !important; border-bottom: 1px dotted #3393d3;');
            $('#newPassword').attr('style', 'width: 230px !important; border-bottom: 1px dotted #3393d3;');
            $('#retypePassword').attr('style', 'width: 250px !important; border-bottom: 1px dotted #3393d3;');
            $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #3393d3;');
            $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #3393d3;');
            $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #3393d3;');

            $('.changePasswordForm .extendedButton').attr('style', 'width: 125px; float: left; background-color: #3393d3;');


            //OrderForm
            $(".orderForm .StepperIconActive").attr('style', 'background-color: #3393d3;');
            $('.orderForm .StepperIcon').attr('style', 'background-color: none;');
            $('.orderForm').attr('style', 'border: 1px solid #3393d3;');
            $('.orderForm #buttonContinue1').attr('style', 'width: 180px; float: left; background-color: #3393d3;');

            $('.orderForm .selectField').attr('style', 'border-bottom: 1px dotted #3393d3;');

            $('.orderForm #TariffProducts').attr('style', 'width: 350px !important; border-bottom: 1px dotted #3393d3;');
            $('.orderForm #ContractStart').attr('style', 'width: 210px; border-bottom: 1px dotted #3393d3;');
            $('.orderForm #Via').attr('style', 'border-bottom: 1px dotted #3393d3;');
            $('.orderForm #ContractEnd').attr('style', 'border-bottom: 1px dotted #3393d3;');
            $('.orderForm #PaymentTerms').attr('style', 'width: 170px; float: left; background-color: #3393d3;');
            $('.orderForm #buttonBack2').attr('style', 'width: 180px; float: left; background-color: #3393d3;');
            $('.orderForm #buttonContinue2').attr('style', 'width: 180px; float: left; background-color: #3393d3;');
            $('.orderForm #TariffProduct_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #3393d3;');
            $('.orderForm #Payment_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #3393d3;');
            $('.orderForm #buttonBack3').attr('style', 'width: 180px; float: left; background-color: #3393d3;');
            $('.orderForm #btoOrderOrder').attr('style', 'width: 180px; float: left; background-color: #3393d3;');

            $(".orderForm .extendedButton").mouseenter(function() {
              $(this).attr('style', 'background-color: #0078c8; width: 180px; float: left;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #3393d3; width: 180px; float: left;');
            });

            //CustomerDucoments
            $('#MenuItem_Bearbeiten').attr('style', 'background-color: #3393d3;');
            $('#MenuItem_Hinzufügen').attr('style', 'background-color: #3393d3;');
            $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #3393d3; border-bottom: 5px solid #3393d3; z-index: 1;');  

            //DocumentUpload
            $('.documentUploadForm').attr('style', 'border: 1px solid #3393d3;');
            $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #3393d3;');
            $('.documentUploadForm #btoChoose').attr('style', 'background-color: #3393d3; width: 150px !important;');
            $('.documentUploadForm #btoFileUpload').attr('style', 'background-color: #3393d3; width: 170px !important; float: left;');
            $('.documentUploadForm #btoCancel').attr('style', 'background-color: #3393d3; width: 170px !important; float: left;');

            //VerificationUpload
            $('.verificationUploadForm').attr('style', 'border: 1px solid #3393d3;');
            $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #3393d3;');
            $('#CertificateType').attr('style', 'width: 340px; float: left; border-bottom: 1px dotted #3393d3;');
            $('.verificationUploadForm #btoChoose').attr('style', 'background-color: #3393d3; width: 150px; float: left;');
            $('.verificationUploadForm #btoFileUpload').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.verificationUploadForm #btoClose').attr('style', 'background-color: #3393d3; width: 170px; float: left;');

            //CreateAdditionalAddress
            $('#AddressTypes').attr('style', 'border-bottom: 1px dotted #3393d3;');
            $('.CreateAdditionalAddressForm #btoCreateAAddress').attr('style', 'background-color: #3393d3; width: 170px; float: left;');
            $('.CreateAdditionalAddressForm #Cancel').attr('style', 'background-color: #3393d3; width: 170px; float: right;');
            $('.CreateAdditionalAddressForm .textfield').attr('style', 'width: 170px; border-bottom: 1px dotted #3393d3;');
            $('.CreateAdditionalAddressForm #Street').attr('style', 'width: 375px; border-bottom: 1px dotted #3393d3;');

            //Contracts
            $('#MenuItem_Download_CSV').attr('style', 'background-color: #3393d3;');
            $('#MenuItem_Add').attr('style', 'background-color: #3393d3;');

            //Account
            $(".accountForm #btoChangePassword").attr('style', 'width: 170px; background-color: #3393d3;');
            $(".accountForm #btoDeleteAccount").attr('style', 'width: 170px; background-color: #3393d3;');
            $('.accountForm').attr('style', 'border: 1px solid #3393d3;');

            $('.footer').attr('style', 'background-color: #3393d3;');
            $('.activeTabTerms').attr('style', 'background-color: #0078c8;');
            $('.tabTerms').attr('style', 'background-color: #3393d3;');

            $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #3393d3;');
            $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #3393d3;');

            $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #3393d3;');

            $('#CancelationReasons').attr('style', 'width: 360px; border-bottom: 1px dotted #3393d3;');
            $('#Check').attr('style', 'width: 177px; float: left; background-color: #3393d3;');
            $('#Abort').attr('style', 'width: 172px; float: left; background-color: #3393d3;');

            $('#PopUpBoxdpCancelationDateHeader').attr('style', 'background-color: #3393d3;');

            if(schriftgröße == "5" || schriftgröße == "0"){
              $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #3393d3;');
              $('#Cancel').attr('style', 'width: 394px; float: right; background-color: #3393d3;');
              $('#Abort').attr('style', 'width: 394px; float: left; background-color: #3393d3; margin-bottom: 10px;');
            }

            $('#btoOrderChange').attr('style', 'width: 180px; float: left; background-color: #3393d3;');

            $('.selected').attr('style', 'background-color: #3393d3 !important; border-bottom: 1px solid #3393d3;');
          } else {

            $('#DataTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
            });

            $('#PaymentTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
            });

            $('#DocumentTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
            });

            $('#CertificateTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
            });

            $('#AddidionalAdressesTabLinkBurgerMenu').mouseenter(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
            }).mouseleave(function() {
                $(this).attr('style', 'background-color: #ffffff; color: black !important;');
                $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');
            });

            $(".activeTabBurgerMenu").attr('style', 'background-color: #1d5c87; color: white !important;');

            $(".NavBar").attr('style', 'background-color: #1d5c87;');
          $(".active").attr('style', 'background-color: #00375b;');
          $(".NavBarItem :hover").attr('style', 'background-color: #00375b;');
          $(".NavBarItem").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87;');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #1d5c87;');
              $(".active").attr('style', 'background-color: #00375b;');
          });
          $(".languageMenuLogin").attr('style', 'background-color: #1d5c87;');
          $(".languageMenuLogin-items").attr('style', 'background-color: #1d5c87; border: 1px solid #1d5c87;');
          $("#MenuItemsLang").attr('style', ' border: 1px solid #1d5c87;');
          $('#LanguagesButon').attr('style', 'margin-left: 10px; border: medium none; background-color: #1d5c87;');
          $('#LanguageButtonDeu').attr('style', 'border: medium none !important; background-color: #1d5c87;');
          $('#LanguageButtonEng').attr('style', 'border: medium none !important; background-color: #1d5c87;');
          $('.customerCard').attr('style', 'border: 1px solid #1d5c87;');
          $('#languageDivDeu').attr('style', 'background-color: #1d5c87; border-bottom-color: #1d5c87;');
          $('#languageDivEng').attr('style', 'background-color: #1d5c87; border-bottom-color: #1d5c87;');
          $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87; color: #1d5c87;');
          $(".activeTab").attr('style', 'background-color: #1d5c87;');
          //$('.tab').attr('style', 'background-color: #ffffff; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
          $(".customerCardLinks td").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
          }).mouseleave(function() {
              $(this).attr('style', 'background-color: #ffffff; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
              $(".activeTab").attr('style', 'background-color: #1d5c87;');
          }).mousedown(function() {
            $("#DataTabLink").removeClass().addClass("tab");
            $("#PaymentTabLink").removeClass().addClass("tab");
            $("#DocumentTabLink").removeClass().addClass("tab");
            $("#CertificateTabLink").removeClass().addClass("tab");
            $("#AddidionalAdressesTabLink").removeClass().addClass("tab");
            $("#ContractDataTabLink").removeClass().addClass("tab");
            $("#RelationDeleteTabLink").removeClass().addClass("tab");
            $('.tab').attr('style', 'color: black; background-color: #ffffff; border-right: 1px solid #1d5c87; border-bottom: 1px solid #1d5c87');
            $("#UsernameDataLink").attr('style', 'background-color: #1d5c87; color: white; border-right: 1px solid #ffffff;');
            $(this).attr('style', 'background-color: #1d5c87;');
          });

          $("#UsernameDataLink").attr('style', 'background-color: #1d5c87; color: white; border-right: 1px solid #ffffff;');
          $("#SignoutDataLink").attr('style', 'background-color: #1d5c87;');

          $('#PersonalDataLink').attr('style', 'background-color: #1d5c87;');
          $('#NewContractDataLink').attr('style', 'background-color: #1d5c87;');
          $('#ContractDataLink').attr('style', 'background-color: #1d5c87;');
          $('.active').attr('style', 'background-color: #00375b;');
          
          $('.MessageBoxTitle').attr('style', 'background-color: #1d5c87;');
          $('.modalLoadingBox').attr('style', 'background-color: rgba(29, 92, 135, 0.6);');
          $('#messageBoxExtendedButton').attr('style', 'background-color: #1d5c87; width: 150px; float: right;');
          $('.SideNav').attr('style', 'width: auto; background-color: #1d5c87;');
          $(".SideNav table td").mouseenter(function() {
            $(this).attr('style', 'color: white; cursor: pointer; background-color: #00375b;');
          }).mouseleave(function() {
              $(this).attr('style', 'color: white; cursor: pointer; background-color: #1d5c87;');
          });
  
          //Forms
          $('.tariffingForm').attr('style', 'text-align: left; border-bottom: 1px solid #1d5c87;');

          $('.contractForm .pagingTable th, .contractForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
          $('.customerForm .pagingTable th, .customerForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');

          if (role === '3'){

            $('.contractForm th[id="0"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 92px !important; cursor: pointer; padding-right: 130px !important;');
            $('.contractForm th[id="1"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 195px !important;');
            $('.contractForm th[id="2"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 195px !important;');
            $('.contractForm th[id="3"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 130px !important;');
            $('.contractForm th[id="4"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 130px !important;');
            $('.contractForm th[id="5"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 95px !important; cursor: pointer;');
            $('.contractForm th[id="6"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; width: 95px !important; cursor: pointer;');
            $('.contractForm th[id="7"]').attr('style', 'color: #1d5c87; border-bottom: 1px solid #1d5c87; cursor: pointer;');

            $('.panel').attr('style', 'border: 1px solid #1d5c87; box-shadow: 10px 10px 15px #1d5c87;');
            $('.panelHeader').attr('style', 'background-color: #1d5c87;');
            $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');
          }
  
          //Buttons
          $('.extendedButton, .pagingButton').attr('style', 'background-color: #1d5c87;');
          $('.extendedButton, .pagingButton, .pagingButtonPicker').attr('style', 'background-color: #1d5c87; width: 30px; height: 30px;');
          $('.extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#changeMail').attr('style', 'width: 175px; float: left; background-color: #1d5c87;');
          $('#changeMailCancel').attr('style', 'width: 175px; float: right; background-color: #1d5c87;');
          $('.customerDataContainerEditButtonNoIconsAdditionalAddressEdit > div:nth-child(1) > div:nth-child(1) > table:nth-child(1) > tbody:nth-child(1) > tr:nth-child(1) > td:nth-child(2) > div:nth-child(1) > button:nth-child(1)').attr('style', 'background-color: #1d5c87; width: 100px;');

          //Msc Fields
          $('.checkbox').attr('style', 'accent-color: #1d5c87; float: left; margin-left: 0px;');
          $('.focusedCheckBox').attr('style', 'accent-color: #1d5c87; float: left; margin-left: 0px;');
  
          //Fields
          $('.textfield').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.textfieldDisabled').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.textfield#EMail').attr('style', 'width: 280px;');
          $('.datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox').attr('style', 'color: rgb(89, 89, 89);');
          $('.registerform > div:nth-child(1) > div:nth-child(7) > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) > label:nth-child(1)').attr('style', 'width: 390px; float: left;');
          $('.datefield, .textfield, .emailfield, .numfield, .selectField').attr('style', 'width: 103px; border-bottom: 1px dotted #1d5c87;');  
          $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
          $('#FileTextLabel').attr('style', 'width: 300px; float: left;');
          $('#email2').attr('style', 'width: 360px; float: border-bottom: 1px dotted #1d5c87;');

          //CustomerPayment
          $('.customerCard th, .contractCard th').attr('style', 'border-bottom: 1px solid #1d5c87; color: #1d5c87;');
          $('.createPaymentForm .pagingTable th, .createPaymentForm .pagingTableWithoutBorder th').attr('style', 'padding-right: 0px; color: #1d5c87; border-bottom: 1px solid #1d5c87;');
          $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
          $('.createPaymentForm .pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');

          $('.createPaymentForm #PaymentTerms').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.createPaymentForm #CreatePayment').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.createPaymentForm #Cancel').attr('style', 'background-color: #1d5c87; width: 170px; float: right;');
          $('.createPaymentForm #iban2').attr('style', 'border-bottom: 1px dotted #1d5c87; width: 315px;');

          $('.createPaymentForm #ValidFrom').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');
          $('.createPaymentForm #ValidTo').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');
          $('.createPaymentForm #DateOfBirth').attr('style', 'background-color: #1d5c87; width: 140px; float: left;');
        
          //PagingTable
          $('#Data > tr:nth-child(2n) > td > table > tbody > tr > td').attr('style', 'background-color: none; border-bottom: none;');
          $('#Data > tr > td > table > tbody > tr > td').attr('style', 'border-bottom: none;');
          $(".pagingTable tbody tr, .pagingTableWithoutBorder tbody tr").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          }).mouseleave(function() {
            $(this).attr('style', 'background-color: #ffffff !important; border-bottom: 1px solid #1d5c87;');
          });

          $(".selected").mouseenter(function() {
            $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');
          });

          $(".pagingTable tbody tr:nth-child(2n), .pagingTableWithoutBorder tbody tr:nth-child(2n)").attr('style', 'background-color: rgba(29, 92, 135, 0.1); border-bottom: 1px solid #1d5c87;');

          $('#btoChoose').attr('style', 'background-color: #1d5c87; width: 100px;');
          $('.page').attr('style', 'width: 25px; margin-right: 5px; text-align: center; border: 1px solid #1d5c87;');

          $('#oldPassword').attr('style', 'width: 250px !important; border-bottom: 1px dotted #1d5c87;');
          $('#newPassword').attr('style', 'width: 230px !important; border-bottom: 1px dotted #1d5c87;');
          $('#retypePassword').attr('style', 'width: 250px !important; border-bottom: 1px dotted #1d5c87;');
          $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

          $('.changePasswordForm .extendedButton').attr('style', 'width: 125px; float: left; background-color: #1d5c87;');

        //OrderForm
          $(".orderForm .StepperIconActive").attr('style', 'background-color: #1d5c87;');
          $('.orderForm .StepperIcon').attr('style', 'background-color: none;');
          $('.orderForm').attr('style', 'border: 1px solid #1d5c87;');
          $('.orderForm #buttonContinue1').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

          $('.orderForm .selectField').attr('style', 'border-bottom: 1px dotted #1d5c87;');

          $('.orderForm #TariffProducts').attr('style', 'width: 350px; border-bottom: 1px dotted #1d5c87;');
          $('.orderForm #ContractStart').attr('style', 'width: 210px; border-bottom: 1px dotted #1d5c87;');
          $('.orderForm #Via').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.orderForm #ContractEnd').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.orderForm #PaymentTerms').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
          $('.orderForm #buttonBack2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
          $('.orderForm #buttonContinue2').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
          $('.orderForm #TariffProduct_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
          $('.orderForm #Payment_ButtonBack').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
          $('.orderForm #buttonBack3').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
          $('.orderForm #btoOrderOrder').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');

          $(".orderForm .extendedButton").mouseenter(function() {
            $(this).attr('style', 'background-color: #00375b; width: 180px; float: left;');
        }).mouseleave(function() {
            $(this).attr('style', 'background-color: #1d5c87; width: 180px; float: left;');
          });

          //CustomerDucoments
          $('#MenuItem_Bearbeiten').attr('style', 'background-color: #1d5c87;');
          $('#MenuItem_Hinzufügen').attr('style', 'background-color: #1d5c87;');
          $(".loaderSmall, .loaderComponent").attr('style', 'border-top: 5px solid #1d5c87; border-bottom: 5px solid #1d5c87; z-index: 1;');  

          //DocumentUpload
          $('.documentUploadForm').attr('style', 'border: 1px solid #1d5c87;');
          $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
          $('.documentUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px !important;');
          $('.documentUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px !important; float: left;');
          $('.documentUploadForm #btoCancel').attr('style', 'background-color: #1d5c87; width: 170px; float !important: left;');

          //VerificationUpload
          $('.verificationUploadForm').attr('style', 'border: 1px solid #1d5c87;');
          $('#FileText').attr('style', 'width: 300px; float: left; border-bottom: 1px dotted #1d5c87;');
          $('#CertificateType').attr('style', 'width: 340px; float: left; border-bottom: 1px dotted #1d5c87;');
          $('.verificationUploadForm #btoChoose').attr('style', 'background-color: #1d5c87; width: 150px; float: left;');
          $('.verificationUploadForm #btoFileUpload').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.verificationUploadForm #btoClose').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');

          //CreateAdditionalAddress
          $('#AddressTypes').attr('style', 'border-bottom: 1px dotted #1d5c87;');
          $('.CreateAdditionalAddressForm #btoCreateAAddress').attr('style', 'background-color: #1d5c87; width: 170px; float: left;');
          $('.CreateAdditionalAddressForm #Cancel').attr('style', 'background-color: #1d5c87; width: 170px; float: right;');
          $('.CreateAdditionalAddressForm .textfield').attr('style', 'width: 170px; border-bottom: 1px dotted #1d5c87;');
          $('.CreateAdditionalAddressForm #Street').attr('style', 'width: 375px; border-bottom: 1px dotted #1d5c87;');

          //Contracts
          $('#MenuItem_Download_CSV').attr('style', 'background-color: #1d5c87;');
          $('#MenuItem_Add').attr('style', 'background-color: #1d5c87;');

          //Account
          $(".accountForm #btoChangePassword").attr('style', 'width: 170px; background-color: #1d5c87;');
          $(".accountForm #btoDeleteAccount").attr('style', 'width: 170px; background-color: #1d5c87;');
          $('.accountForm').attr('style', 'border: 1px solid #1d5c87;');

          $('.footer').attr('style', 'background-color: #1d5c87;');
          $('.activeTabTerms').attr('style', 'background-color: #00375b;');
          $('.tabTerms').attr('style', 'background-color: #1d5c87;');

          $('#btoContractChange').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('#btoContractCancel').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');
          $('.contractDetailsForm .extendedButton').attr('style', 'width: 120px; float: right; background-color: #1d5c87;');

          $('#CancelationReasons').attr('style', 'width: 360px; border-bottom: 1px dotted #1d5c87;');
          $('#Check').attr('style', 'width: 177px; float: left; background-color: #1d5c87;');
          $('#Abort').attr('style', 'width: 172px; float: left; background-color: #1d5c87;');

          $('#PopUpBoxdpCancelationDateHeader').attr('style', 'background-color: #1d5c87;');

          if(schriftgröße == "5" || schriftgröße == "0"){
            $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
            $('#Cancel').attr('style', 'width: 394px; float: right; background-color: #1d5c87;');
            $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
          }

          $('#btoOrderChange').attr('style', 'width: 180px; float: left; background-color: #1d5c87;');
          $('.selected').attr('style', 'background-color: #1d5c87 !important; border-bottom: 1px solid #1d5c87;');

        }
      }
    };

    FontSizeClick(condition){
      var schriftgröße = localStorage.getItem('Schriftgröße');
      var kontrastNumber = localStorage.getItem('Kontrast');
      let role = localStorage.getItem("vas_role");
      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
            if(condition){

                switch(schriftgröße){
                    case "0":
                      $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".footer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_33").addClass("Schriftgröße_28");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $('#tabContent').removeClass("TabContentPaddingLeft100").addClass("TabContentPaddingLeft1");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.ItemData').removeClass("ItemDataWidth270").addClass("ItemDataWidth190");
                      $('.ItemContracts').removeClass('width160').addClass('width110');
                      $('.ItemNewContract').removeClass('width240').addClass('width210');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL55").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_28").addClass("Schriftgröße_18");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.StepperLabel').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_Empty').removeClass('tariffProductEmptyHeight_25');

                      $('#From, #To').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.termsOfUsage').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#btoChooseDocument').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_ButtonBack').removeClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1102").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#MenuItem_Add').removeClass("downloadCsvPadding_1102").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_17").addClass("Schriftgröße_12");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");
                        $('.link').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                        $('.panel').removeClass("ItemDataWidth270").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');
                          $('.active').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');
                      }

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                        $('#Abort').attr('style', 'width: 172px; float: left; background-color: #1d5c87;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 170px; float: left;');
                        $('#Cancel').attr('style', 'width: 170px; float: right;');
                        $('#Abort').attr('style', 'width: 172px; float: left;');
                      }

                      $("#UploadSuccessText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $("#LinkLogin").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      localStorage.setItem('Schriftgröße', '1');

                    break;
                    case "1":
                      $("#root").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".footer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_28").addClass("Schriftgröße_29");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#tabContent').removeClass("TabContentPaddingLeft1").addClass("TabContentPaddingLeft20");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.ItemData').removeClass("ItemDataWidth190").addClass("ItemDataWidth210");
                      $('.customerCardSubTitle').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_18").addClass("Schriftgröße_20");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.StepperLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#From, #To').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.termsOfUsage').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#btoChooseDocument').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_ButtonBack').addClass('marginTop_5');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_14").addClass("Schriftgröße_15").addClass("downloadCsvPadding_1106");
                      $('#MenuItem_Add').removeClass("Schriftgröße_14").addClass("Schriftgröße_15").addClass("downloadCsvPadding_1106");

                      $('.ItemContracts').removeClass('width110').addClass('width120');

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_12").addClass("Schriftgröße_13");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        $('.link').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');
                          $('.active').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');
                      }

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 170px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                        $('#Abort').attr('style', 'width: 172px; float: left; background-color: #1d5c87;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 170px; float: left;');
                        $('#Cancel').attr('style', 'width: 170px; float: right;');
                        $('#Abort').attr('style', 'width: 172px; float: left;');
                      }

                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -10px !important;');
                    
                      $("#UploadSuccessText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $("#LinkLogin").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      localStorage.setItem('Schriftgröße', '2');
                    break;
                    case "2":
                      $("#root").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".footer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_5").addClass("Schriftgröße_16");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_29").addClass("Schriftgröße_30");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#tabContent').removeClass("TabContentPaddingLeft20").addClass("TabContentPaddingLeft40");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth210");
                      $('.ItemContracts').removeClass('width120').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL45");
                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL10");
    
                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_20").addClass("Schriftgröße_22");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.StepperLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#From, #To').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.termsOfUsage').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoChooseDocument').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_ButtonBack').removeClass('marginTop_5').addClass('marginTop_10');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#MenuItem_Add').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_13").addClass("Schriftgröße_14");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                        $('.link').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('html body div#root.Schriftgröße_16 div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass("paddingLeft0").addClass("paddingLeft20");

                        $('.tablinks').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
                          $('.active').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
                      }

                      $('.LinkTextOnline').attr('style', 'padding-left: 4px !important; padding-right: 2px !important;');
                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -10px !important;');

                      $("#UploadSuccessText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $("#LinkLogin").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      localStorage.setItem('Schriftgröße', '3');
                    break;
                    case "3":
                      $("#root").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".footer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_30").addClass("Schriftgröße_31");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#tabContent').removeClass("TabContentPaddingLeft40").addClass("TabContentPaddingLeft60");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth230");
                      $('.ItemContracts').removeClass('width140').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_22").addClass("Schriftgröße_24");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.StepperLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_21");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_Empty').addClass('tariffProductEmptyHeight_25');

                      $('#From, #To').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.termsOfUsage').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#btoChooseDocument').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_ButtonBack').removeClass('marginTop_10').addClass('marginTop_15');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1106").removeClass("Schriftgröße_16").addClass("Schriftgröße_17").addClass("downloadCsvPadding_1104");
                      $('#MenuItem_Add').removeClass("downloadCsvPadding_1106").removeClass("Schriftgröße_16").addClass("Schriftgröße_17").addClass("downloadCsvPadding_1104");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                        $('.link').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
                          $('.active').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
                      }

                      $("#UploadSuccessText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $("#LinkLogin").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      localStorage.setItem('Schriftgröße', '4');
                    break;
                    case "4":
                      $("#root").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".footer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_31").addClass("Schriftgröße_32");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $('#tabContent').removeClass("TabContentPaddingLeft60").addClass("TabContentPaddingLeft80");
                      $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.ItemData').removeClass("ItemDataWidth230").addClass("ItemDataWidth250");
                      $('.ItemContracts').removeClass('width140').addClass('width160');
                      $('.ItemNewContract').removeClass('width210').addClass('width230');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_24").addClass("Schriftgröße_26");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.StepperLabel').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#From, #To').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.termsOfUsage').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#btoChooseDocument').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_ButtonBack').removeClass('marginTop_15').addClass('marginTop_20');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1104").removeClass("Schriftgröße_17").addClass("Schriftgröße_18").addClass("downloadCsvPadding_1102");
                      $('#MenuItem_Add').removeClass("downloadCsvPadding_1104").removeClass("Schriftgröße_17").addClass("Schriftgröße_18").addClass("downloadCsvPadding_1102");
                      
                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $('.personalDataForm #btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                        $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                        $('#Cancel').attr('style', 'width: 170px; float: right;');
                        $('#Abort').attr('style', 'width: 394px; float: left; margin-bottom: 10px;');
                      }

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
                        $('.link').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
                        $('.active').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
                      }

                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -12px !important;');

                      $("#UploadSuccessText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $("#LinkLogin").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      localStorage.setItem('Schriftgröße', '5');
                    break;
                    case "5":
                      $("#root").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".footer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_32").addClass("Schriftgröße_33");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $('#tabContent').removeClass("TabContentPaddingLeft80").addClass("TabContentPaddingLeft100");
                      $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.ItemData').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");
                      $('.ItemContracts').removeClass('width160').addClass('width160');
                      $('.ItemNewContract').removeClass('width230').addClass('width240');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL45").addClass("tableHeaderPaddingL55");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL10").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_26").addClass("Schriftgröße_28");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.StepperLabel').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#From, #To').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.termsOfUsage').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoChooseDocument').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_ButtonBack').removeClass('marginTop_20').addClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#MenuItem_Add').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $('.ContainerLeftHint').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                        $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                        $('#Cancel').attr('style', 'width: 170px; float: right;');
                        $('#Abort').attr('style', 'width: 394px; float: left; margin-bottom: 10px;');
                      }

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");
                        $('.link').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");

                        $('.tablinks').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
                        $('.active').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
                      }

                      if(kontrastNumber == "true"){
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                        $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                        $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
                      } else {
                        $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                        $('#Cancel').attr('style', 'width: 170px; float: right;');
                        $('#Abort').attr('style', 'width: 394px; float: left; margin-bottom: 10px;');
                      }

                      $("#UploadSuccessText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $("#LinkLogin").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      localStorage.setItem('Schriftgröße', '0');
                    break;
                }

            } else {
              switch(schriftgröße){
                case "0":
                      $("#root").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".footer").removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_32").addClass("Schriftgröße_33");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                      $('#tabContent').removeClass("TabContentPaddingLeft80").addClass("TabContentPaddingLeft100");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.ItemData').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");
                      $('.ItemContracts').removeClass('width160').addClass('width160');
                      $('.ItemNewContract').removeClass('width230').addClass('width240');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL45").addClass("tableHeaderPaddingL55");
                      $('html body div#root.Schriftgröße_21 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft100 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL10").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_26").addClass("Schriftgröße_28");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.StepperLabel').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#From, #To').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('.termsOfUsage').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoChooseDocument').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#Payment_ButtonBack').removeClass('marginTop_20').addClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#MenuItem_Add').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");
                        $('.link').removeClass("Schriftgröße_22").addClass("Schriftgröße_23");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth270");

                        $('.tablinks').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
                        $('.active').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
                      }

                      $('.LinkTextOnline').attr('style', 'padding-left: 4px !important; padding-right: 2px !important;');
                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -12px !important;');

                      $("#DownloadDocument").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $(".accordion").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    $("#chooseMotiv").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#chooseMotiv1").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#chooseMotiv2").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#chooseMotiv3").removeClass("Schriftgröße_18").addClass("Schriftgröße_19"); 
                    
                    $(".extendedButton ").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    $("#noMotiv").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#noMotivHint").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");  
                    $("#noMotivLink").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $("#i-0, #i-1, #i-2, #i-3, #i-4, #i-5, #i-6, #i-7, #i-8, #i-9").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                    if(kontrastNumber == "true"){
                      $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                      $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                      $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
                    } else {
                      $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                      $('#Cancel').attr('style', 'width: 170px; float: right;');
                      $('#Abort').attr('style', 'width: 394px; float: left; margin-bottom: 10px;');
                    }

                    $("#UploadSuccessText").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                    $("#LinkLogin").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                break;
                case "1":

                      $("#root").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".footer").removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_33").addClass("Schriftgröße_28");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_21").addClass("Schriftgröße_16");
                      $('#tabContent').removeClass("TabContentPaddingLeft100").addClass("TabContentPaddingLeft1");
                      $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.ItemData').removeClass("ItemDataWidth270").addClass("ItemDataWidth190");
                      $('.ItemContracts').removeClass('width160').addClass('width110');
                      $('.ItemNewContract').removeClass('width240').addClass('width210');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').addClass("tableHeaderPaddingL10");
                      $('html body div#root.Schriftgröße_16 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft1 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL55").addClass("tableHeaderPaddingL25");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_28").addClass("Schriftgröße_18");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.StepperLabel').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#From, #To').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('.termsOfUsage').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#btoChooseDocument').removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#Payment_ButtonBack').removeClass('marginTop_25');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1102").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                      $('#MenuItem_Add').removeClass("downloadCsvPadding_1102").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_22").addClass("Schriftgröße_17");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");
                        $('.link').removeClass("Schriftgröße_23").addClass("Schriftgröße_18");

                        $('.panel').removeClass("ItemDataWidth270").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');
                        $('.active').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');
                      }

                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -12px !important;');

                    $("#UploadSuccessText").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                    $("#LinkLogin").removeClass("Schriftgröße_19").addClass("Schriftgröße_14");
                break;
                case "2":
                      $("#root").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".footer").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_28").addClass("Schriftgröße_29");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#tabContent').removeClass("TabContentPaddingLeft1").addClass("TabContentPaddingLeft20");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.ItemData').removeClass("ItemDataWidth190").addClass("ItemDataWidth210");
                      $('.customerCardSubTitle').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_18").addClass("Schriftgröße_20");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.StepperLabel').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#From, #To').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('.termsOfUsage').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");

                      $('#btoChooseDocument').removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                      $('#Payment_ButtonBack').addClass('marginTop_5');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_14").addClass("Schriftgröße_15").addClass("downloadCsvPadding_1106");
                      $('#MenuItem_Add').removeClass("Schriftgröße_14").addClass("Schriftgröße_15").addClass("downloadCsvPadding_1106");

                      $('.ItemContracts').removeClass('width110').addClass('width120');

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                        $('.link').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');
                        $('.active').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');
                      }

                    $("#UploadSuccessText").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                    $("#LinkLogin").removeClass("Schriftgröße_14").addClass("Schriftgröße_15");
                break;
                case "3":
                      $("#root").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".footer").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_5").addClass("Schriftgröße_16");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_29").addClass("Schriftgröße_30");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#tabContent').removeClass("TabContentPaddingLeft20").addClass("TabContentPaddingLeft40");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_0").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth210");
                      $('.ItemContracts').removeClass('width120').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#2.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL45");
                      $('html body div#root.Schriftgröße_18 div div div.personalDataForm table.customerCard tbody tr td#tabContent.TabContentPaddingLeft40 div#customerPayment table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#3.tableHeaderHeader table thead tr th.tableHeader').removeClass("tableHeaderPaddingL25").addClass("tableHeaderPaddingL10");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_20").addClass("Schriftgröße_22");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.StepperLabel').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#From, #To').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('.termsOfUsage').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoChooseDocument').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#Payment_ButtonBack').removeClass('marginTop_5').addClass('marginTop_10');

                      $('#MenuItem_Download_CSV').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                      $('#MenuItem_Add').removeClass("Schriftgröße_15").addClass("Schriftgröße_16");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                        $('.link').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('html body div#root.Schriftgröße_19 div div div.form.customerForm div table tbody tr td table#table.pt tbody tr td table.pagingTableWithoutBorder thead tr th#1.tableHeaderHeader table thead tr th.tableHeader').removeClass("paddingLeft0").addClass("paddingLeft20");

                        $('.tablinks').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
                        $('.active').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
                      }

                      $('.LinkTextOnline').attr('style', 'padding-left: 4px !important; padding-right: 2px !important;');
                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -10px !important;');

                    $("#UploadSuccessText").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                    $("#LinkLogin").removeClass("Schriftgröße_15").addClass("Schriftgröße_16");
                break;
                case "4":
                      $("#root").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".footer").removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_30").addClass("Schriftgröße_31");
    
                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_18").addClass("Schriftgröße_19");
                      $('#tabContent').removeClass("TabContentPaddingLeft40").addClass("TabContentPaddingLeft60");
                      $('#btoChoose').removeClass("btoChooseWidth100_0").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.ItemData').removeClass("ItemDataWidth210").addClass("ItemDataWidth230");
                      $('.ItemContracts').removeClass('width140').addClass('width140');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_22").addClass("Schriftgröße_24");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.StepperLabel').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#From, #To').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('.termsOfUsage').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");

                      $('#btoChooseDocument').removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                      $('#Payment_ButtonBack').removeClass('marginTop_10').addClass('marginTop_15');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1106").removeClass("Schriftgröße_16").addClass("Schriftgröße_17").addClass("downloadCsvPadding_1104");
                      $('#MenuItem_Add').removeClass("downloadCsvPadding_1106").removeClass("Schriftgröße_16").addClass("Schriftgröße_17").addClass("downloadCsvPadding_1104");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");
                        $('.link').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
                        $('.active').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
                      }

                      $('.LinkTextOnline').attr('style', 'padding-left: 4px !important; padding-right: 2px !important;');
                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -10px !important;');
                    
                    $("#UploadSuccessText").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                    $("#LinkLogin").removeClass("Schriftgröße_16").addClass("Schriftgröße_17");
                break;
                case "5":
                  $("#root").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".pagingButtonPicker, .extendedButton, .pagingButton, .disabledExtendedButton, .roundExtendedButton, .roundDisabledExtendedButton").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".datefieldLabel, .textfieldLabel, .emailfieldLabel, .numfieldLabel, .selectFieldLabel, .cbox").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".footer").removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $(".datefield, .textfield, .emailfield, .numfield").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".selectField, .selectFieldNotFilled").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $(".SideNavOffline table td").removeClass("Schriftgröße_31").addClass("Schriftgröße_32");

                      $('.datefieldDisabled, .textfieldDisabled, .emailfieldDisabled, .numfieldDisabled').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#LanguagesButon, #LanguageButtonDeu, #LanguageButtonEng').removeClass("Schriftgröße_19").addClass("Schriftgröße_20");
                      $('#tabContent').removeClass("TabContentPaddingLeft60").addClass("TabContentPaddingLeft80");
                      $('#btoChoose').removeClass("btoChooseWidth100_40").addClass("btoChooseWidth100_40").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.ItemData').removeClass("ItemDataWidth230").addClass("ItemDataWidth250");
                      $('.ItemContracts').removeClass('width140').addClass('width160');
                      $('.ItemNewContract').removeClass('width210').addClass('width230');
                      $('.customerCardSubTitle').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $("#MenuItem_Bearbeiten").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $("#MenuItem_Hinzufügen").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('.StepperIcon, .StepperIconActive').removeClass("Schriftgröße_24").addClass("Schriftgröße_26");
                      $('.ConfirmationLabel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.StepperLabel').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                      $('#TariffProduct_TicketNameHeadline, #TariffProduct_TicketName').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractStartHeadline, #TariffProduct_ContractStart').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_FromHeadline, #TariffProduct_DescriptionLongFrom').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ToHeadline, #TariffProduct_DescriptionLongTo').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_TzViaLabel, #TariffProduct_TzViaText').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceHeadline, #TariffProduct_Price').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_PriceLevelHeadline, #TariffProduct_PriceLevel').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#TariffProduct_ContractEndHeadline, #TariffProduct_ContractEnd').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_PaymentHeadline, #Payment_Payment').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#From, #To').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('.termsOfUsage').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");

                      $('#btoChooseDocument').removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                      $('#Payment_ButtonBack').removeClass('marginTop_15').addClass('marginTop_20');

                      $('#MenuItem_Download_CSV').removeClass("downloadCsvPadding_1104").removeClass("Schriftgröße_17").addClass("Schriftgröße_18").addClass("downloadCsvPadding_1102");
                      $('#MenuItem_Add').removeClass("downloadCsvPadding_1104").removeClass("Schriftgröße_17").addClass("Schriftgröße_18").addClass("downloadCsvPadding_1102");

                      $('#btoCreateAddress, .CreateAdditionalAddressForm #Cancel').removeClass('width350FloatR').addClass('width350FloatR');

                      $('#customerCardHeadline').removeClass("Schriftgröße_20").addClass("Schriftgröße_21");

                      if (role === '3'){
                        $('.copen').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");
                        $('.link').removeClass("Schriftgröße_21").addClass("Schriftgröße_22");

                        $('.panel').removeClass("ItemDataWidth250").addClass("ItemDataWidth250");

                        $('.tablinks').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
                        $('.active').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
                      }

                      $('.LinkTextOnline').attr('style', 'padding-left: 4px !important; padding-right: 2px !important;');
                      $('div.ItemNewContract > a:nth-child(1)').attr('style', 'padding-left: 4px !important; padding-right: 2px !important; margin-top: -12px !important;');

                    if(kontrastNumber == "true"){
                      $('#btoCreateAAddress').attr('style', 'width: 394px; float: left; background-color: #1d5c87;');
                      $('#Cancel').attr('style', 'width: 170px; float: right; background-color: #1d5c87;');
                      $('#Abort').attr('style', 'width: 394px; float: left; background-color: #1d5c87; margin-bottom: 10px;');
                    } else {
                      $('#btoCreateAAddress').attr('style', 'width: 394px; float: left;');
                      $('#Cancel').attr('style', 'width: 170px; float: right;');
                      $('#Abort').attr('style', 'width: 394px; float: left; margin-bottom: 10px;');
                    }

                    $("#UploadSuccessText").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                    $("#LinkLogin").removeClass("Schriftgröße_17").addClass("Schriftgröße_18");
                break;
              }
            }
        }
    };

    render(){

        if (localStorage.getItem("vas_selectedTab") !== null)
        {
            this.DeselectTabs();

            this.SelectTab(localStorage.getItem("vas_selectedTab"));
        }

        let country = '';
        let countryTab = <td></td>;
        if(this.LangConfig.OnlyGerman === false){
          if (localStorage.getItem("vas_language") === "de"){
            country = (<Icon
              Name={"FlagGermany"}
              Align={"left"} />);
          } else {
              country = (<Icon
                Name={"FlagUnitedKingdom"}
                Align={"left"} />);
          }

          countryTab = <td
            id="LanguageDataLink"
            className={TransdevMenue.LanguageDataLinkClass}
            onMouseOver={()=>{this.showFlags();}}
            onMouseLeave={()=>{this.hideFlags();}} >
              <table>
                <tbody>
                  <tr>
                    <td>
                      {country}
                    </td>
                    <td>
                    <div style={{ display:'inline', verticalAlign:'middle' }}>
              <button
                id="LanguagesButon"
                className={TransdevMenue.LanguageDataLinkClass}
                style={{border:"none", width:'80px !important'}}
                onKeyDown={(e)=>{if(e.keyCode === 13){
                  this.showFlags();
                }}}
                >{Vas.Resources.Labels["Language"]}</button>
            </div>
            <div
              id="MenuItemsLang"
              className={'languageMenuLogin-items-notVisible'} >
              <div id="languageDivDeu" onClick={()=>{this.SetLanguage("de");}}><button
                    id="LanguageButtonDeu"
                    className={TransdevMenue.LanguageDataLinkClass}
                    style={{border:"none"}}
                    onKeyDown={(e)=>{if(e.keyCode === 13){
                      this.SetLanguage("de");
                    }}}
                    >Deutsch</button></div>
              <div id="languageDivEng" onClick={()=>{this.SetLanguage("en");}}><button
                  id="LanguageButtonEng"
                  className={TransdevMenue.LanguageDataLinkClass}
                  style={{border:"none"}}
                  onKeyDown={(e)=>{if(e.keyCode === 13){
                    this.SetLanguage("en");
                  }}}
                  >English</button></div>
            </div>
                    </td>
                  </tr>
                </tbody>
              </table>
             
            
          </td>
        }
        
        let customers = <td></td>;
        if(localStorage.getItem('vas_role') === "3"){
          if(this.AdminConfig.ShowPanels === false){
            customers = <td
              id="CustomersDataLink"
              className={TransdevMenue.CustomersDataLinkClass}
              onClick={()=>{ Vas.GetView("Customers", null, true); }}>
              <div className={"NavBarItemIcon"}>
                <Icon
                  Name={"Person"}
                  Size={24}
                  Color={"white"}
                  Align={"left"} />
              </div>
              <div className={"NavBarItemText ItemCustomers"}>
              <a href={Vas.GetView("Customers",null,true,true)} className={TransdevMenue.CustomersDataLinkText} onClick={()=>{localStorage.setItem("vas_selectedTab","CustomersDataLink");}}>{Vas.Resources.Labels["Employee"]}</a>

                
              </div>
            </td>
          }
          
        }

        let newContract = <td></td>;
        if(localStorage.getItem('vas_role') === "1"){
          newContract = <td
            id="NewContractDataLink"
            className={TransdevMenue.NewContractDataLinkClass}
            onClick={()=>{
              localStorage.setItem("vas_selectedTab","NewContractDataLink"); 
              let id = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id') : localStorage.getItem('vas_customerId');
              if(localStorage.getItem('vas_role') === "3"){
                  Vas.GetView("Order", { CustomerId: id, ContractId : '00000' }, true);
              }else{
                  this.PaymentsModel.GetPaymentsByCustomerId(id,null, null, null, null, null, 4);
              }
              
            }}
          >
            <div className={"NavBarItemIcon"}>
              <Icon
                Name={"Contracts"}
                Size={24}
                Color={"white"}
                Align={"left"} />
            </div>
            <div className={"NavBarItemText ItemNewContract"}>
            <a href={"javascript:console.log('')"} 
            className={TransdevMenue.NewContractDataLinkText} 
            onClick={()=>{
                localStorage.setItem("vas_selectedTab","NewContractDataLink"); 
                let id = localStorage.getItem('employee_id') ? localStorage.getItem('employee_id') : localStorage.getItem('vas_customerId');
                if(localStorage.getItem('vas_role') === "3"){
                    Vas.GetView("Order", { CustomerId: id, ContractId : '00000' }, true);
                }else{
                    this.PaymentsModel.GetPaymentsByCustomerId(id,null, null, null, null, null, 4);
                }
            }}>{Vas.Resources.Labels["PriceInformation"]}</a>
              
            </div>
          </td> 
        }

        let personal = <td
            id="PersonalDataLink"
            className={TransdevMenue.PersonalDataLinkClass}
            onClick={()=>{ Vas.GetView("CustomerCard", { Id: localStorage.getItem("vas_customerId") }, true); }}
            >
            <div className={"NavBarItemIcon"}>
              <Icon
                Name={"Account"}
                Size={24}
                Color={"white"}
                Align={"left"} />
            </div>
            <div className={"NavBarItemText ItemData"}>
            <a href={Vas.GetView("CustomerCard",{ Id: localStorage.getItem("vas_customerId") },true,true)} className={TransdevMenue.PersonalDataLinkText} onClick={()=>{localStorage.setItem("vas_selectedTab","PersonalDataLink");}}>{Vas.Resources.Labels["Account"]}</a>
            </div>
          </td>;
        let contract = <td
            id="ContractDataLink"
            className={TransdevMenue.ContractDataLinkClass}
            onClick={()=>{ Vas.GetView("Contracts", {All:true}, true); }}
            >
            <div className={"NavBarItemIcon"}>
              <Icon
                Name={"Contracts"}
                Size={24}
                Color={"white"}
                Align={"left"} />
            </div>
            <div className={"NavBarItemText ItemContracts"}>
            <a href={Vas.GetView("Contracts",{All:true},true,true)} className={TransdevMenue.ContractDataLinkText} onClick={()=>{localStorage.setItem("vas_selectedTab","ContractDataLink");}}>{Vas.Resources.Labels["Contracts"]}</a>
             
            </div>
          </td>;
        
        let home = <td></td>;

        if(localStorage.getItem('vas_role') === "3"){
          if(this.AdminConfig.ShowPanels === true){
            personal =<td></td>;
            contract = <td></td>;
            home = <td
                id="HomeDataLink"
                className={TransdevMenue.HomeDataLinkClass}
                onClick={()=>{ Vas.GetView("Home", null, true); }}>
                <div className={"NavBarItemIcon"}>
                  <Icon
                    Name={"Account"}
                    Size={24}
                    Color={"white"}
                    Align={"left"} />
                </div>
                <div className={"NavBarItemText ItemData"}>
                <a href={Vas.GetView("Home",null,true,true)} className={TransdevMenue.HomeDataLinkText} onClick={()=>{localStorage.setItem("vas_selectedTab","HomeDataLink");}}>{Vas.Resources.Menus["Home"]}</a>
                  
                </div>
              </td>;
          }
        }
        

        return (
          <div className={"Menue"}>
            <div className={"MenueLogo"}>
              <img
                alt={""}
                className={"VrrLogo"}
                src={document.location.origin + "/images/" + Vas.Config.Icons.IconLoggedIn}
                onClick={()=>{document.getElementById("mySidenav").style.width = "250px";}} />
              <img
                  className={"Kontrast"}
                  src={document.location.origin + "/images/Kontrast.png"}
                  alt={"Kontrast_erhöhen"} 
                  onClick={()=>{ this.LogoClick(true);}}/>

              <img
                  className={"Schriftgröße"}
                  src={document.location.origin + "/images/Schriftgröße.png"}
                  alt={"Kontrast_erhöhen"} 
                  onClick={()=>{ this.FontSizeClick(true);}}/>
            </div>

            <div className={"NavBar"} >
              <table style={{ width: '100%' }} >
                <tbody>
                  <tr>   
                    {home}                           
                    {personal}
                    {newContract}
                    {contract}
                    {customers}
                    <td
                      id="empty"
                      className={TransdevMenue.Empty}>
                    </td>
                    <td
                      id="UsernameDataLink"
                      className={TransdevMenue.UsernameDataLinkClass}
                      onClick={()=>{ Vas.GetView("Account", null, true); }}>
                      <div className={"NavBarItemIcon"}>
                        <Icon
                          Name={"Person"}
                          Size={24}
                          Color={"white"}
                          Align={"left"} />
                      </div>
                      <div className={"NavBarItemText ItemAccount"}>
                      <a href={Vas.GetView("Account",null,true,true)} className={TransdevMenue.UsernameDataLinkText} onClick={()=>{localStorage.setItem("vas_selectedTab","UsernameDataLink");}}>{ localStorage.getItem("vas_username")}</a>
                                                                
                      </div>
                    </td>
                    {countryTab}
                    <td
                      id="SignoutDataLink"
                      className={TransdevMenue.SignOut}
                      onClick={()=>{ Vas.Signout();}}
                      >
                      <div className={"NavBarItemIcon"}>
                        <Icon
                          Name={"SignOut"}
                          Size={24}
                          Color={"white"}
                          Align={"left"} />
                      </div>
                      <div className={"NavBarItemText ItemSignOut"}>
                      <a href={'javascript:Vas.Signout();'} className={TransdevMenue.SignOutLinkText} onClick={()=>{Vas.Signout();}}>{Vas.Resources.Labels["SignOut"]}</a>
                        
                      </div>
                    </td>
                    <td className={"BurgerMenu"}><Icon
                      Name={"Menu"}
                      Size={36}
                      Color={"white"} />
                      <SideNavigation />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>            
        );
    }
}
export default TransdevMenue;
